export default function (url, options, timeout) {
  const hasAbortController = typeof AbortController !== 'undefined';

  if (!hasAbortController) {
    // Fallback to original implementation for older environments
    return Promise.race([
      fetch(url, options),
      new Promise((_, reject) => {
        setTimeout(() => {
          const err = new Error('Timeout Error');
          err.name = 'AbortError';
          reject(err);
        }, timeout);
      }),
    ]);
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeout);

  // Merge abort signal with existing options
  const fetchOptions = {
    ...options,
    signal: controller.signal,
  };

  return Promise.race([
    fetch(url, fetchOptions),
    new Promise((_, reject) => {
      // Handle abort signal
      controller.signal.addEventListener('abort', () => {
        clearTimeout(timeoutId);
        const err = new Error('Timeout Error');
        err.name = 'AbortError';
        reject(err);
      });
    }),
  ]);
}
